<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
  <form class="form" [formGroup]="model" (ngSubmit)="submit()" enctype="multipart/form-data">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Arquivo</h1>
      </div>
    </div>

    <div class="row">
        <!-- Seleção de Categoria -->
        <div class="col-md-6">
            <mat-form-field appearance="outline">
            <mat-label>Selecione uma categoria</mat-label>
            <mat-select formControlName="listaCategoriaArquivo" (selectionChange)="onSelectedCategoriaArquivo()">
                @if(_categoriaLookupResponse){
                    @for (categoriaArquivo of _categoriaLookupResponse.listaCategoriaArquivo; track categoriaArquivo) {
                        <mat-option [value]="categoriaArquivo.idCategoriaArquivo">
                        {{ categoriaArquivo.nome }}
                        </mat-option>
                    }
                }
            </mat-select>
            @if (model.get('listaCategoriaArquivo')?.invalid) {
                <mat-error>Selecione uma categoria</mat-error>
            }
            </mat-form-field>
        </div>
      
        <!-- Campo para tag de arquivo-->
        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Tag</mat-label>
                <mat-chip-grid #chipGrid [formControl]="formControlTagArquivo">
                    @if (selectedTagArquivo) {
                        <mat-chip-row (removed)="removeTagArquivo()">
                            {{ selectedTagArquivo.nome }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input matInput formControlName="tagArquivo"
                    placeholder="Buscar tag para o arquivo"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodesTagArquivo"
                    [matChipInputAddOnBlur]="false">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectedTagArquivo($event)" [displayWith]="displayTag">
                    @for (tag of filteredTagArquivo | async; track tag) {
                        <mat-option [value]="tag">
                            {{ tag.nome }}
                        </mat-option>
                    }
                </mat-autocomplete>
                @if (formControlTagArquivo.invalid) {
                    <mat-error>Informe uma tag para o arquivo</mat-error>
                }
            </mat-form-field>
        </div>      
    </div>

    <div class="row">
        <!-- Versão -->
        <div class="col-md-6">
            <mat-form-field appearance="outline">
            <mat-label>Versão</mat-label>
            <input matInput formControlName="versao" type="text">
            @if (model.get('versao')?.invalid) {
                <mat-error>Informe uma versão</mat-error>
            }
            </mat-form-field>
        </div>      
    </div>

    <div class="row">
      <!-- Upload do arquivo -->
      <div class="col-md-6 file-upload">
        <label for="input-file">Carregar um arquivo</label>
        @if(arquivoNome !== ""){
          <p class="file-select">{{ arquivoNome }}</p>
        }
        <input id="input-file" formControlName="uploadFile" type="file" (change)="onFileChange($event)">
        @if (model.get('uploadFile')?.invalid) {
          <mat-error>Informe um arquivo</mat-error>
      }
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <button type="submit" mat-flat-button class="btn-primary button-big">
          @if (_isLoading === true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
          @else {
            Salvar
          }
        </button>
      </div>
    </div>
  </form>
</div>
